import { render, staticRenderFns } from "./form-select.vue?vue&type=template&id=18d717f5&scoped=true"
import script from "./form-select.ts?vue&type=script&lang=ts&external"
export * from "./form-select.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d717f5",
  null
  
)

export default component.exports